import { Link } from 'react-router-dom';
import { latestNews, newsList } from '@/mocks/news';

export default function NewsHighlights() {
  const [lead, ...rest] = latestNews;
  const secondary = rest.length > 0 ? rest : newsList.slice(1, 3);

  return (
    <section className="w-full bg-background-50 px-4 py-12 md:px-8 md:py-16">
      <div className="mx-auto w-full max-w-[1400px]">
        <div className="flex flex-wrap items-end justify-between gap-3">
          <div>
            <p className="font-label text-xs uppercase tracking-[0.2em] text-accent-600">Film &amp; TV News</p>
            <h2 className="mt-2 font-display text-2xl font-bold text-foreground-950 md:text-3xl">精选影视资讯</h2>
            <p className="mt-2 text-sm text-foreground-500">新片上线的第一手消息、影评解读与行业观察</p>
          </div>
          <Link
            to="/news"
            className="flex items-center gap-1 whitespace-nowrap rounded-md border border-background-300/70 px-3.5 py-1.5 text-sm text-foreground-700 transition-colors hover:border-accent-400 hover:text-accent-700"
          >
            全部资讯 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="mt-6 grid grid-cols-1 gap-5 lg:grid-cols-[1.15fr_1fr]">
          <Link to={`/news/${lead.id}`} className="group overflow-hidden rounded-lg border border-background-200/70 bg-background-50">
            <div className="relative h-[220px] w-full overflow-hidden bg-background-200 md:h-[300px]">
              <img
                src={lead.cover}
                alt={lead.title}
                title={`${lead.title} - 影视资讯`}
                className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-[1.03]"
              />
              <span className="absolute left-3 top-3 rounded-md bg-accent-500 px-2 py-0.5 text-[11px] font-bold text-foreground-950">
                {lead.category}
              </span>
            </div>
            <div className="p-4 md:p-5">
              <h3 className="font-display text-base font-bold leading-snug text-foreground-950 group-hover:text-accent-700 md:text-lg">
                {lead.title}
              </h3>
              <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-500">{lead.summary}</p>
              <p className="mt-3 flex items-center gap-2 text-xs text-foreground-400">
                <i className="ri-user-3-line"></i>
                {lead.author}
                <span className="text-background-400">·</span>
                {lead.date}
              </p>
            </div>
          </Link>

          <div className="flex flex-col gap-3">
            {secondary.map((item) => (
              <Link
                key={item.id}
                to={`/news/${item.id}`}
                className="group flex flex-1 gap-3 rounded-lg border border-background-200/70 bg-background-50 p-3 transition-colors hover:border-accent-300 hover:bg-background-100"
              >
                <div className="h-20 w-28 shrink-0 overflow-hidden rounded-md bg-background-200 md:h-24 md:w-36">
                  <img
                    src={item.cover}
                    alt={item.title}
                    title={`${item.title} - 影视资讯`}
                    className="h-full w-full object-cover object-top"
                  />
                </div>
                <div className="min-w-0 flex-1">
                  <span className="text-[11px] font-medium text-accent-700">{item.category}</span>
                  <h3 className="mt-1 line-clamp-2 text-sm font-semibold leading-snug text-foreground-950 group-hover:text-accent-700">
                    {item.title}
                  </h3>
                  <p className="mt-1.5 line-clamp-1 text-xs text-foreground-500">{item.summary}</p>
                  <p className="mt-1.5 text-[11px] text-foreground-400">{item.date}</p>
                </div>
              </Link>
            ))}
            <div className="rounded-lg border border-accent-200 bg-accent-50 p-4">
              <p className="flex items-center gap-1.5 text-xs font-semibold text-accent-800">
                <i className="ri-notification-3-line"></i>
                每周更新影视资讯与片单
              </p>
              <p className="mt-1.5 text-xs leading-relaxed text-accent-900/70">
                关注「影视资讯」频道，第一时间获取新片上线提醒与编辑推荐。
              </p>
              <Link
                to="/news"
                className="mt-3 inline-flex items-center gap-1 whitespace-nowrap rounded-md bg-primary-950 px-3 py-1.5 text-xs font-medium text-background-50 transition-colors hover:bg-primary-800"
              >
                前往资讯频道 <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}